import validationComponent from './validation.component';
import validationConfig from './validation.config';
import PromoQuizValidationService from './validationService.factory';

export default angular.module('app.promo.promoQuiz.tools.validation', [])
.config(validationConfig)
.component('promoQuizValidation', validationComponent)
.factory('PromoQuizValidationService', PromoQuizValidationService);
